// extracted by mini-css-extract-plugin
export default {"groupCopyButton":"CopyModal_groupCopyButton__XHceP","formInputCopy":"CopyModal_formInputCopy__QPnm2"};